/* Package JSON Import will be here */
import React from "react";
import { Spin } from "antd";
/* Package JSON Import will be here */

export const Spinner = props => {
  return (
    <Spin tip={props.message} className="spinner-width" />
  );
};

export const ButtonSpinner = props => {
  return (
    <Spin size="small" className="pl-2" />
  );
};

export const BannerPlaceholder = () => {
  return <div className="banner-placeholder" />;
};

export const ImageLoader = () => {
  return (
    <div className="loaderAnimation"></div>
  );
};